import React, { useEffect, useState, Fragment } from 'react'
import { Card,Col,Container,Form,InputGroup,Row} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { formato_rut, isValidParam } from '../../../common/Formatos'
import { obtenerDatosNoFormato } from '../../../store/actions/implicado-action'

const Implicado = ({ formik,setPaisImplicadoFinal }) => {
  const data_datos_generales = useSelector((state) => state.casoGeneralReducer)
  const { cfg_form_implicado, antecedentesCasos } = data_datos_generales
  const data_datos_implicado = useSelector((state) => state.implicadoReducer)
  const { datosPantalla, comboPais, comboComunas } = data_datos_implicado

  const [datosSiniestro, setDatosSiniestro] = useState({})
  const [rutImplicado, setRutImplicado] = useState('')
  const [rutImplicadoNoFormato, setRutImplicadoNoFormato] = useState('')
  const [nombreImplicado, setNombreImplicado] = useState('')
  const [direccionImplicado, setDireccionImplicado] = useState('')
  const [emailImplicado, setEmailImplicado] = useState('')
  const [paisImplicado, setPaisImplicado] = useState('')
  const [paisMovilImplicado, setPaisMovilImplicado] = useState('')
  const [fonoImplicado, setFonoImplicado] = useState('')
  const [movilImplicado, setMovilImplicado] = useState('')
  const [comunaImplicado, setComunaImplicado] = useState('')
  const [ciudadImplicado, setCiudadImplicado] = useState('')
  const [obsImplicado, setObsImplicado] = useState('')

const distpatch=useDispatch()
  useEffect(() => {
    
    distpatch(obtenerDatosNoFormato(rutImplicadoNoFormato))
  }, [rutImplicadoNoFormato])
  useEffect(() => {
    setPaisImplicadoFinal(paisImplicado)
  }, [paisImplicado])
  useEffect(() => {
    setRutImplicado(
      datosPantalla &&
        datosPantalla.datosPantalla[0]['RutImplicado'] !== undefined &&
        datosPantalla.datosPantalla[0]['RutImplicado'] !== null
        ? formato_rut(
            datosPantalla.datosPantalla[0]['RutImplicado']
            // + datosPantalla.datosPantalla['RutImplicado']
          )
        : ''
    )
    setRutImplicadoNoFormato(
      datosPantalla && datosPantalla.datosPantalla[0]['RutImplicado']
      //+ datosPantalla.datosPantalla['dvIdGirador']
    )
    setNombreImplicado(
      datosPantalla &&
        datosPantalla.datosPantalla[0]['NombreImplicado'] !== undefined &&
        datosPantalla.datosPantalla[0]['NombreImplicado'] !== null &&
        datosPantalla.datosPantalla[0]['NombreImplicado'] !== ''
        ? datosPantalla.datosPantalla[0]['NombreImplicado']
        : ''
    )
    setDireccionImplicado(
      datosPantalla &&
        datosPantalla.datosPantalla[0]['DireccionImplicado'] !== undefined &&
        datosPantalla.datosPantalla[0]['DireccionImplicado'] !== null &&
        datosPantalla.datosPantalla[0]['DireccionImplicado'] !== ''
        ? datosPantalla.datosPantalla[0]['DireccionImplicado']
        : ''
    )
    setEmailImplicado(
      datosPantalla &&
        datosPantalla.datosPantalla[0]['EmailImplicado'] !== undefined &&
        datosPantalla.datosPantalla[0]['EmailImplicado'] !== null &&
        datosPantalla.datosPantalla[0]['EmailImplicado'] !== ''
        ? datosPantalla.datosPantalla[0]['EmailImplicado']
        : ''
    )
    setPaisImplicado(18002)
    setPaisMovilImplicado(18002)
    setFonoImplicado(
      datosPantalla &&
        datosPantalla.datosPantalla[0]['FonoImplicado'] !== undefined &&
        datosPantalla.datosPantalla[0]['FonoImplicado'] !== null &&
        datosPantalla.datosPantalla[0]['FonoImplicado'] !== ''
        ? datosPantalla.datosPantalla[0]['FonoImplicado']
        : ''
    )
    setMovilImplicado(
      datosPantalla &&
        datosPantalla.datosPantalla[0]['MovilImplicado'] !== undefined &&
        datosPantalla.datosPantalla[0]['MovilImplicado'] !== null &&
        datosPantalla.datosPantalla[0]['MovilImplicado'] !== ''
        ? datosPantalla.datosPantalla[0]['MovilImplicado']
        : ''
    )
    setComunaImplicado(
      datosPantalla &&
        datosPantalla.datosPantalla[0]['IdComunaImplicado'] !== undefined &&
        datosPantalla.datosPantalla[0]['IdComunaImplicado'] !== null &&
        datosPantalla.datosPantalla[0]['IdComunaImplicado'] !== ''
        ? datosPantalla.datosPantalla[0]['IdComunaImplicado']
        : ''
    )
    if( datosPantalla &&
      datosPantalla.datosPantalla[0]['IdComunaImplicado'] !== undefined &&
      datosPantalla.datosPantalla[0]['IdComunaImplicado'] !== null &&
      datosPantalla.datosPantalla[0]['IdComunaImplicado'] !== ''){
      const comunaActual = comboComunas &&
        comboComunas.comboComunas?.find(
          (c) => c.id ===datosPantalla.datosPantalla[0]['IdComunaImplicado']
        )
        setCiudadImplicado(comunaActual && comunaActual.atr4)
    }
    if (datosPantalla && isValidParam(datosPantalla.datosPantalla[0]['obsImplicado'])) {
      setObsImplicado(datosPantalla.datosPantalla[0]['obsImplicado']);
    }   
  }, [datosPantalla])
  return (
    <>
      {/* <Container> */}
      <Card className='mt-1 '>
        <Card.Header
          className='mt-0 mb-0'
          as='h6'
          style={{ backgroundColor: '#D9EDF6', color: '#8578CD' }}
        >
          {cfg_form_implicado
            ? cfg_form_implicado.cfg_form_implicado[
                'gestcasosrecup-editimpl-title-tabimplicado'
              ]
            : null}
        </Card.Header>
        <Container>
          {cfg_form_implicado ? (
            <div>
              <Row>
                <Col md="3">
                  <Form.Label
                    className='mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form_implicado.cfg_form_implicado[
                        'gestcasosrecup-editimpl-rutimpl'
                      ]
                    }
                  </Form.Label>{' '}
                  <br />
                  <Form.Control
                    className='mt-2 w-75'
                    autoComplete='off'
                    onChange={(e) => {
                      formik.handleChange(e)
                      setRutImplicado(e.target.value)
                      setRutImplicadoNoFormato(e.target.value)
                    }}
                    value={
                      (formik.values.rutImplicado =
                        rutImplicado !== undefined && rutImplicado)
                    }
                    onFocus={() =>
                      rutImplicado !== ''
                        ? setRutImplicado(rutImplicadoNoFormato)
                        : ''
                    }
                    onBlur={() => {
                      setRutImplicado(formato_rut(rutImplicado))
                    }}
                    name='rutImplicado'
                    error={formik.errors.rutImplicado}
                  ></Form.Control>
                  {formik.errors.rutImplicado ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.rutImplicado}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                </Col>
                <Col md="4">
                  <Form.Label
                    className=' mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form_implicado.cfg_form_implicado[
                        'gestcasosrecup-editimpl-nomimpl'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <Form.Control
                    className='mt-2 w-75'
                    value={
                      (formik.values.nombreImplicado =
                        nombreImplicado !== undefined && nombreImplicado)
                    }
                    onChange={(e) => {
                      formik.handleChange(e)
                      setNombreImplicado(e.target.value)
                    }}
                    name='nombreImplicado'
                    error={formik.errors.nombreImplicado}
                  ></Form.Control>
                  {formik.errors.nombreImplicado ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.nombreImplicado}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                </Col>
                <Col md="4">
                  <Form.Label
                    className='mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form_implicado.cfg_form_implicado[
                        'gestcasosrecup-editimpl-dirimpl'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <Form.Control
                    className='mt-2'
                    value={
                      (formik.values.direccionImplicado =
                        direccionImplicado !== undefined && direccionImplicado)
                    }
                    onChange={(e) => {
                      formik.handleChange(e)
                      setDireccionImplicado(e.target.value)
                    }}
                    name='direccionImplicado'
                    error={formik.errors.direccion}
                  ></Form.Control>
                  {formik.errors.direccionImplicado ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.direccionImplicado}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                </Col>
              </Row>
              <Row>
              <Col md="3">
                  <Form.Label
                    className=' mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form_implicado.cfg_form_implicado[
                        'gestcasosrecup-editimpl-emailimpl'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <Form.Control
                    className='mt-2'
                    value={
                      (formik.values.emailImplicado =
                        emailImplicado !== undefined && emailImplicado)
                    }
                    onChange={(e) => {
                      formik.handleChange(e)
                      setEmailImplicado(e.target.value)
                    }}
                    name='emailImplicado'
                    error={formik.errors.emailImplicado}
                  ></Form.Control>
                  {formik.errors.emailImplicado ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.emailImplicado}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                </Col>
                <Col md="4">
                  <Form.Label
                    className='mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form_implicado.cfg_form_implicado[
                        'gestcasosrecup-editimpl-fonoimpl'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <InputGroup className='mb-3 w-75'>
                    <Form.Select
                      className='mt-2 w-25'
                      aria-label='Default select example'
                      onChange={(e) => {
                        formik.handleChange(e)

                        setPaisImplicado(e.target.value)
                      }}
                      name='paisImplicado'
                      value={(formik.values.paisImplicado = paisImplicado)}
                      error={formik.errors.paisImplicado}
                    >
                      <option value={''}>Seleccione...</option>
                      {comboPais &&
                        comboPais.comboPais?.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.nombre}
                          </option>
                        ))}
                    </Form.Select>
                    {formik.errors.pais ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.pais}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                    <Form.Control
                      className='mt-2 w-50'
                      value={
                        (formik.values.fonoImplicado =
                          fonoImplicado !== undefined && fonoImplicado)
                      }
                      onKeyDown={(e) => {
                        //validaNumeros(e)
                      }}
                      onChange={(e) => {
                        formik.handleChange(e)
                        setFonoImplicado(e.target.value)
                      }}
                      name='fonoImplicado'
                      error={formik.errors.fonoImplicado}
                    ></Form.Control>
                    {formik.errors.fonoImplicado ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.fonoImplicado}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                  </InputGroup>
                </Col>
                <Col md="4"> 
                  <Form.Label className='mt-3 mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                    {cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-movilimpl']}
                  </Form.Label>
                  <br />
                  <InputGroup className='mb-3 w-75'>
                    <Form.Select
                      className='mt-2 w-25'
                      aria-label='Default select example'
                      onChange={(e) => {
                        formik.handleChange(e)
                        setPaisMovilImplicado(e.target.value)
                      }}
                      name='paisMovilImplicado'
                      value={(formik.values.paisMovilImplicado = paisMovilImplicado)}
                      error={formik.errors.paisMovilImplicado}
                    >
                      <option value={''}>Seleccione...</option>
                      {comboPais &&
                        comboPais.comboPais?.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.nombre}
                          </option>
                        ))}
                    </Form.Select>
                    {formik.errors.paisMovilImplicado ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.paisMovilImplicado}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                    <Form.Control
                      className='mt-2 w-50'
                      value={
                        (formik.values.movilImplicado =
                          movilImplicado !== undefined && movilImplicado)
                      }
                      onChange={(e) => {
                        formik.handleChange(e)
                        setMovilImplicado(e.target.value)
                      }}
                      name='movilImplicado'
                      error={formik.errors.movilImplicado}
                    ></Form.Control>
                    {formik.errors.movilImplicado ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.movilImplicado}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                  </InputGroup>
                </Col>
                </Row>
                <Row>
                <Col md="3">
                  <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                    {cfg_form_implicado.cfg_form_implicado['gestcasosrecupeditimpl-comunaimpl']}
                  </Form.Label>
                  <br />
                  <InputGroup className='mb-3 w-75'>
                    <Form.Select
                      className='mt-2 w-75'
                      aria-label='Default select example'
                      onChange={(e) => {
                        formik.handleChange(e)
                        const comunaActual =
                          comboComunas &&
                          comboComunas.comboComunas?.find(
                            (c) => c.id === e.target.value
                          )
                        setCiudadImplicado(comunaActual.atr4)
                        setComunaImplicado(e.target.value)
                      }}
                      name='comunaImplicado'
                      value={(formik.values.comunaImplicado = comunaImplicado)}
                      error={formik.errors.comunaImplicado}
                    >
                      <option value={''}>Seleccione...</option>
                      {comboComunas &&
                        comboComunas.comboComunas?.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.nombre}
                          </option>
                        ))}
                    </Form.Select>
                    {formik.errors.comunaImplicado ? (
                      <Form.Text variant='danger' style={{ color: 'red' }}>
                        {formik.errors.comunaImplicado}
                      </Form.Text>
                    ) : (
                      ''
                    )}
                  </InputGroup>
                </Col>
                <Col>
                  <Form.Label className='mb-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                    {cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-ciudadimpl']}
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                    {ciudadImplicado}
                  </Form.Text>
                </Col>
              </Row>
              <Row>
                <Col md="10">
                  <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                    {cfg_form_implicado.cfg_form_implicado['gestcasosrecupeditimpl-obs'] ? cfg_form_implicado.cfg_form_implicado['gestcasosrecupeditimpl-obs'] : "Observaciones"}
                  </Form.Label>
                  <br />
                  <Form.Control as="textarea" 
                    className='mt-2 mb-2' 
                    rows={2} 
                    onChange={e=>{                    
                      formik.handleChange(e)
                      setObsImplicado(e.target.value)                        
                    }}
                    name='obsImplicado'                   
                    value={formik.values.obsImplicado = obsImplicado}
                    error={formik.errors.obsImplicado}  
                  />
                  {formik.errors.obsImplicado ? (
                    <Form.Text variant="danger" style={{color:"red"}} >
                      {formik.errors.obsImplicado}
                    </Form.Text>
                  ) : "" }
                  
                </Col>
              </Row>
              <Row><Col><br></br></Col></Row>
            </div>
          ) : null}
        </Container>
      </Card>
    </>
  )
}

export default Implicado
